module.exports = __webpack_public_path__ + "static/India-411f8270df337751103785d27dba72a2.jpg";